import Api from "./Api";

class ReportApi extends Api {
  url = `${process.env.VUE_APP_XHR_ROOT}`;

  send(data) {
    const url = this.prepareUrl("certification/user/report/");
    return this.requestPost(url, data);
  }
}

export default new ReportApi();
